import React from "react";
import Row from "../../common/layout/row";

export default function AbasGraficos({ abaAtiva, setAbaAtiva }) {
    return (
        <Row style={{ width: "100%", maxWidth: "100%", boxSizing: "border-box", display: "flex", justifyContent: "center", paddingTop: 10 }}>
            {[{ id: "dia", titulo: "Dia" }, { id: "mes", titulo: "Mês" }, { id: "ano", titulo: "Ano" }].map((aba) => (
                <button
                    key={aba.id}
                    type="button"
                    onClick={() => setAbaAtiva(aba.id)}
                    style={{
                        minWidth: 0,
                        flex: "1 1 0",
                        maxWidth: 110,
                        padding: "10px 20px",
                        border: "1px solid #ddd",
                        borderBottom: abaAtiva === aba.id ? "2px solid #0070cc" : "1px solid #ddd",
                        background: abaAtiva === aba.id ? "#fff" : "#f5f5f5",
                        color: abaAtiva === aba.id ? "#0070cc" : "#555",
                        fontWeight: abaAtiva === aba.id ? 600 : 400,
                        cursor: "pointer",
                    }}
                >
                    {aba.titulo}
                </button>
            ))}
        </Row>
    );
}
